// extracted by mini-css-extract-plugin
export default {"animationContainer":"encumbrance-notification_animationContainer__4i5Uq","animation":"encumbrance-notification_animation__csW0v","message":"encumbrance-notification_message__OLdP1"};